import * as types from "../actions/actionTypes";
import initialState from "./initialState.js";

export default function homeDataReducer(state = initialState.topicsData, action) {
    const newState = { ...state };
    switch (action.type) {
        default:
            return state;
    }
}
